import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { Header } from "@/components/site/Header";
import { HeroChicago } from "@/components/site/HeroChicago";
import { NorwoodQuiz } from "@/components/site/NorwoodQuiz";
import { ValueProps } from "@/components/site/ValueProps";
import { Footer } from "@/components/site/Footer";
import { WhyChooseChicago } from "@/components/site/WhyChooseChicago";
import { safeJsonLd } from "@/lib/structured-data";
import { getScottsdaleStructuredData } from "@/lib/structured-data/scottsdale";

const Results = lazy(() => import("@/components/site/Results").then(m => ({ default: m.Results })));
const Reviews = lazy(() => import("@/components/site/Reviews").then(m => ({ default: m.Reviews })));
const NoShaveFuture = lazy(() => import("@/components/site/NoShaveFuture").then(m => ({ default: m.NoShaveFuture })));
const NoShaveWhy = lazy(() => import("@/components/site/NoShaveWhy").then(m => ({ default: m.NoShaveWhy })));
const Guarantee = lazy(() => import("@/components/site/Guarantee").then(m => ({ default: m.Guarantee })));
const Pricing = lazy(() => import("@/components/site/Pricing").then(m => ({ default: m.Pricing })));
const Surgeons = lazy(() => import("@/components/site/Surgeons").then(m => ({ default: m.Surgeons })));
const DoctorsGrid = lazy(() => import("@/components/site/DoctorsGrid").then(m => ({ default: m.DoctorsGrid })));
const LocationsMapScottsdale = lazy(() => import("@/components/site/LocationsMapScottsdale").then(m => ({ default: m.LocationsMapScottsdale })));
const VirtualConsult = lazy(() => import("@/components/site/VirtualConsult").then(m => ({ default: m.VirtualConsult })));
const Faq = lazy(() => import("@/components/site/Faq").then(m => ({ default: m.Faq })));
const QuoteForm = lazy(() => import("@/components/site/QuoteForm").then(m => ({ default: m.QuoteForm })));

export const Route = createFileRoute("/locations/arizona/scottsdale")({
  head: () => ({
    meta: [
      { title: "Get Your Hair Back | RESTORE® Hair Transplants — Scottsdale" },
      { name: "description", content: "Find out about your hair transplant options in Scottsdale with RESTORE® Hair. Over 20,000 procedures performed." },
      { property: "og:title", content: "Get Your Hair Back | RESTORE® Hair Transplants — Scottsdale" },
      { property: "og:description", content: "Top hair restoration team serving Scottsdale. Soft, natural, undetectable results." },
      { property: "og:url", content: "https://restorehair.com/locations/arizona/scottsdale/" },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/locations/arizona/scottsdale/" }],
    scripts: [{ type: "application/ld+json", children: safeJsonLd({ "@graph": getScottsdaleStructuredData() }) }],
  }),
  component: Index,
});

function Index() {
  return (
    <div className="min-h-screen bg-background font-sans">
      <Header />
      <main>
        <HeroChicago
          eyebrow="RESTORE® | Scottsdale Hair Transplants"
          subheading="RESTORE your confidence with the #1 hair restoration team in Scottsdale"
          extraParagraph={
            <>
              Find out about your hair transplant options in Scottsdale.{" "}
              {/* The Phoenix page had one internal link, from /locations/arizona/. */}
              In the Phoenix area?{" "}
              <a href="/locations/arizona/phoenix/" className="underline underline-offset-4">
                Hair transplants in Phoenix
              </a>
            </>
          }
        />
        <NorwoodQuiz />
        <WhyChooseChicago />
        <Suspense fallback={null}>
          <div className="hidden md:block"><Results /></div>
          <ValueProps hideEyebrowMobile />
          <NoShaveFuture />
          <NoShaveWhy dougLeft />
          <Reviews />
          <Guarantee />
          <Pricing city="Scottsdale" />
          <VirtualConsult />
          <Surgeons
            eyebrow="RESTORE Scottsdale Hair Transplant Doctors"
            heading={<>A World Renowned <span className="text-foreground">Team</span></>}
          />
          <DoctorsGrid />
          <LocationsMapScottsdale />
          <Faq />
          <QuoteForm />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}